module.exports = __webpack_public_path__ + "static/media/M1-3-Gabyno-Ogam-cod102.7f1a9cb7.png";